


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"



window.spaWidgetParams = window.spaWidgetParams || {};
                       window.spaWidgetParams['gt-footer-unauth-secure-bofa-widget'] = window.spaWidgetParams['gt-footer-unauth-secure-bofa-widget'] || {};
                       window.spaWidgetParams['gt-footer-unauth-secure-bofa-widget']['1.0.0'] = window.spaWidgetParams['gt-footer-unauth-secure-bofa-widget']['1.0.0'] || {};
window.spaWidgetParams['gt-footer-unauth-secure-bofa-widget']['1.0.0'].dynamicImportMap = {
  modules: [
    {
      name: "@sparta.global.modules/global-social-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/global-global-social-module-es6" */ "@sparta.global.modules/global-social-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/global-global-social-module-styles" */ "@sparta.global.modules/global-social-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.global.vendors/vue",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue" */ "@sparta.global.vendors/vue" )}
    },
    {
      name: "@sparta.global.vendors/vuex",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vuex" */ "@sparta.global.vendors/vuex" )}
    },
    {
      name: "@sparta.global.vendors/vue-router",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue-router" */ "@sparta.global.vendors/vue-router" )}
    }
  ],
  sharedComponents: [
    {
      name: "@sparta.global-tenants.shared-components/gt-footer-unauth-shared-component-footerlink",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-tenants-gt-footer-unauth-shared-component-footerlink-es6" */ "@sparta.global-tenants.shared-components/gt-footer-unauth-shared-component-footerlink/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-button",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-button-es6" */ "@sparta.global.shared-components/spa-vue-button/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-badging",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-badging-es6" */ "@sparta.global.shared-components/spa-vue-badging/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-svg",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-svg-es6" */ "@sparta.global.shared-components/spa-vue-svg/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-modal",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-modal-es6" */ "@sparta.global.shared-components/spa-vue-modal/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-ui-layers",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-ui-layers-es6" */ "@sparta.global.shared-components/spa-vue-ui-layers/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-card",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-card-es6" */ "@sparta.global.shared-components/spa-vue-card/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-link",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-link-es6" */ "@sparta.global.shared-components/spa-vue-link/dist/es6.js" )}
    },
    {
      name: "@sparta.global-tenants.shared-components/gt-footer-unauth-shared-component-copyright",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-tenants-gt-footer-unauth-shared-component-copyright-es6" */ "@sparta.global-tenants.shared-components/gt-footer-unauth-shared-component-copyright/dist/es6.js" )}
    },
    {
      name: "@sparta.global-tenants.shared-components/gt-footer-unauth-shared-component-disclosures",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-tenants-gt-footer-unauth-shared-component-disclosures-es6" */ "@sparta.global-tenants.shared-components/gt-footer-unauth-shared-component-disclosures/dist/es6.js" )}
    },
    {
      name: "@sparta.global-tenants.shared-components/gt-footer-unauth-shared-component-legal-box",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-tenants-gt-footer-unauth-shared-component-legal-box-es6" */ "@sparta.global-tenants.shared-components/gt-footer-unauth-shared-component-legal-box/dist/es6.js" )}
    },
    {
      name: "@sparta.global-tenants.shared-components/gt-footer-unauth-shared-component-footnotes",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-tenants-gt-footer-unauth-shared-component-footnotes-es6" */ "@sparta.global-tenants.shared-components/gt-footer-unauth-shared-component-footnotes/dist/es6.js" )}
    },
    {
      name: "@sparta.global-tenants.shared-components/gt-footer-unauth-shared-component-custom-disclosures",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-tenants-gt-footer-unauth-shared-component-custom-disclosures-es6" */ "@sparta.global-tenants.shared-components/gt-footer-unauth-shared-component-custom-disclosures/dist/es6.js" )}
    }
  ],
  stores: [
    {
      namespace: "@sparta.global-tenants.stores/gt-unauth-footer-store",
                   loader: function() { return import( /* webpackChunkName: "spa-assets/js/stores/@sparta.global-tenants.stores/gt-unauth-footer-store-es6" */ "@sparta.global-tenants.stores/gt-unauth-footer-store/dist/es6.js" )}
    }
  ],
  jcrs: [
    {
      name: "global/en/social/social.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/global-en-social-social.json" */ "file:///apps/wt/webtools/webtools_build_server/tmp/7C6CBE15/build/sit2a_h_s/spa/widgets/gt-footer-unauth-secure-bofa-widget/1.0.0/spa-assets/data/global-en-social-social-en-T1770311974244.json" )}
    },
    {
      name: "global/es/social/social.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/global-es-social-social.json" */ "file:///apps/wt/webtools/webtools_build_server/tmp/7C6CBE15/build/sit2a_h_s/spa/widgets/gt-footer-unauth-secure-bofa-widget/1.0.0/spa-assets/data/global-es-social-social-es-T1770311974244.json" )}
    }
  ]
}



window.spaWidgetParams['gt-footer-unauth-secure-bofa-widget']['1.0.0'].getBootstrapUtilityInstance = function () { return spartaBootstrapUtility; };
